export default {
  welcome: 'Bienvenue',
  we_miss_you: 'Vous nous manquez',
  happy_friday: 'Bon vendredi',
  lazy_sunday: 'Dimanche tranquille',
  loyalty_program: 'Programme de fidélité',
  you_might_also_like: 'Vous aimerez aussi',
  storefront_promo: 'Promo vitrine',
  welcome_members_club: 'Bienvenue au club membres',
  launch_deal: 'Offre de lancement',
};
